<template>
  <div class="activity-questions">
    <draggable handle=".handle" v-model="activityRows" :options="{ disabled: isGroupScoringInEditMode }" @start="drag = true" @end="drag = false" @change="onDragQuestion" :move="checkMove">
      <div v-for="(question, indexRow) in activityRows" :key="indexRow + '_' + question.id" :id="question.id">
        <template v-if="question.type !== 'SurveyCompletion'">
          <!-- Group Scroing Section for Columns -->
          <template>
            <template v-if="isGroupScoringInEditMode && question.type !== 'Section'">
              <div class="col-md-12" v-if="activityData && activityData.hasOwnProperty('canScoreResponses') && activityData.canScoreResponses == true && !doesQuestionHasSectionAboveIt(question, indexRow)">
                <!-- NEW GROUP IN THE EDIT MODE -->
                <div v-if="question && activeEditGroup && activeEditGroup.nextQuestionId === question.id">
                  <slot name="section" />
                </div>

                <!-- NEW GROUP IN THE NON-EDIT MODE -->
                <div v-else class="d-flex justify-content-between group-scoring__container mb-10 group-scoring__container-empty">
                  <span class="cursor_pointer color_4c8ce4 fw-bold" @click="addNewGroup(question, indexRow)">Add Section</span>
                </div>
              </div>
            </template>
            <template v-if="activityData && activityData.hasOwnProperty('canScoreResponses') && activityData.canScoreResponses == true">
              <div class="col-md-12">
                <template>
                  <!-- EXISTING GROUP IN THE EDIT MODE -->
                  <div v-if="activeEditGroup && selectedActivityQuestion && sectionModificationMode == 'ADD' && activeEditGroup.nextQuestionId == question.id && selectedActivityQuestion.nextQuestionId === question.id">
                    <addEditQuestion :options="selectedActivityQuestion" :activityData="activityData" @questionUpdated="onSectionUpdated"></addEditQuestion>
                  </div>

                  <div v-else-if="activeEditGroup && selectedActivityQuestion && sectionModificationMode == 'EDIT' && activeEditGroup.id == question.id && selectedActivityQuestion.id === question.id">
                    <addEditQuestion :options="selectedActivityQuestion" :activityData="activityData" @questionUpdated="onSectionUpdated"></addEditQuestion>
                  </div>

                  <!-- EXISTING GROUP IN THE NON-EDIT MODE -->
                  <div v-else-if="question.type == 'Section'" class="group-scoring__container mb-10 d-flex justify-content-between align-items-center">
                    <div class="col-md-12">
                      <span class="section-title pr-6">{{ question.title }}</span>
                      <img alt="edit-tag" class="cursor_pointer pb-6" src="static/img/activity-configurator/edit-tag.svg" @click="editSection(question, indexRow)" />
                    </div>
                  </div>
                </template>
              </div>
            </template>
          </template>
          <!-- Group Scroing Section for Columns -->
          <draggable handle=".handle" v-if="question.type !== 'Section'" :class="'draggable-row draggable-' + question.columnCount" :group="{ name: 'question' }" :list="question.columns" :options="{ disabled: isGroupScoringInEditMode }" @start="drag = true" @end="drag = false" @change="onDragQuestionColumns" :move="checkMove" :data-indexRow="indexRow">
            <div v-for="(colQuestion, indexCol) in question.columns" ref="columns" :key="indexRow + '_' + indexCol + '_' + colQuestion.id" :id="colQuestion.id" :class="!question.columnCount || question.columnCount == 1 ? 'col-md-12' : question.columnCount == 2 ? 'col-md-6' : 'col-md-4'">
              <template v-if="Object.keys(colQuestion).length === 0">
                <div class="draggable-placeholder"></div>
              </template>

              <template v-if="colQuestion.type !== 'Section'">
                <b-form-checkbox v-if="showDeleteButton" :name="`question-${question.id}`" class="activity-step-checkbox" @change="addToBatchDelete(question, $event)">
                  <span class="pl-23 text-align fs-15"></span>
                </b-form-checkbox>
                <div class="card read_only_question" v-if="selectedActivityQuestion.id !== colQuestion.id">
                  <div class="row">
                    <div v-if="!hideEditBtn" class="col-md-10 p-0">
                      <p class="question_color">
                        <img alt="drag" class="drag_img cursor_grab handle" src="static/img/drag.svg" />
                        <span class>
                          <b>Step {{ colQuestion.stepSequence }}</b> - {{ questionTypes[colQuestion.type] }}</span
                        >
                        <input v-if="colQuestion.isDataMapped" type="text" class="ml-15 input-text readonly small-input" :placeholder="colQuestion.mapLabel" readonly />
                        <span v-if="colQuestion.isSkippable" class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2 pb-2 pl-5 pr-5">Optional</span>
                      </p>
                    </div>

                    <div class="dropleft col-md-2 p-0 text-right" style="white-space: nowrap; float: right" v-if="!hideEditBtn">
                      <img src="static/img/activity-configurator/row-settings.svg" id data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" alt class="settings-action-icon dropdown-toggle" />

                      <ul class="dropdown-menu action-dropdown-menu p-0 dropleft">
                        <!-- EDIT -->
                        <li class="settings-dropdown-item fs-12" :disabled="isDisabled" v-on:click="editColumnQuestion(colQuestion)">
                          Edit
                        </li>

                        <!-- DUPLICATE -->
                        <li class="settings-dropdown-item fs-12" :disabled="isDisabled" v-on:click="checkDuplicate(colQuestion)">
                          Duplicate
                        </li>

                        <!-- BRANCHING -->
                        <li class="settings-dropdown-item fs-12" :disabled="isDisabled" v-on:click="addBranchingForQuestion(colQuestion, colQuestion.index)" v-if="colQuestion.type && applicableBranchingQues.includes(colQuestion.type)">
                          Branching
                        </li>

                        <!-- REORDER -->
                        <li class="settings-dropdown-item fs-12" :disabled="isDisabled" @click="reorderQuestion(indexCol, indexRow)">
                          Reorder
                        </li>
                      </ul>
                    </div>
                    <div class="clearfix"></div>
                    <div class="col-md-12 p-0">
                      <div class="question-section">
                        <div :class="{ 'ml-30 mr-30': !hideEditBtn }">
                          <div class="answer-section">
                            <ActivityStepsView :question="colQuestion" />
                            <div class="option-section" v-if="colQuestion.type && colQuestion.type.toLowerCase() === 'valuepicker'">
                              <div class>
                                <input type="number" class="input-text readonly" placeholder readonly />
                              </div>
                            </div>
                            <div class="option-section" v-if="colQuestion.type && colQuestion.type.toLowerCase() === 'email'">
                              <div class>
                                <input type="email" class="input-text readonly" placeholder readonly />
                              </div>
                            </div>
                            <div class="option-section" v-if="colQuestion.type && colQuestion.type.toLowerCase() === 'location'">
                              <div class>
                                <input type="text" class="input-text readonly" placeholder readonly />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </draggable>
          <!-- Edit Step which are in columns -->
          <template v-if="selectedActivityQuestion.hasOwnProperty('id') && selectedActivityQuestion.id === editColumnQuesion">
            <div class="col-md-12">
              <addEditQuestion :options="selectedActivityQuestion" :activityData="activityData"></addEditQuestion>
            </div>
          </template>
          <!-- Edit Step which are in columns -->

          <!-- If question does not have any columns -->
          <template v-if="question.columns.length == 0 && question.type !== 'Section'">
            <div class="col-md-12">
              <div class="draggable-placeholder" v-if="Object.keys(question).length === 0"></div>

              <template v-if="Object.keys(question).length > 0 && question.type !== 'Section'">
                <div v-if="selectedActivityQuestion.id === question.id">
                  <addEditQuestion :options="selectedActivityQuestion" :activityData="activityData"></addEditQuestion>
                </div>
                <b-form-checkbox v-if="showDeleteButton" :name="`question-${question.id}`" class="activity-step-checkbox" @change="addToBatchDelete(question, $event)">
                  <span class="pl-23 text-align fs-15"></span>
                </b-form-checkbox>
                <div class="card read_only_question" v-if="selectedActivityQuestion.id !== question.id">
                  <div class="row">
                    <div v-if="!hideEditBtn" class="col-md-10 p-0">
                      <p class="question_color">
                        <img alt="drag" v-if="question.type != 'SurveyCompletion'" class="drag_img cursor_grab handle" src="static/img/drag.svg" />
                        <span class>
                          <b>Step {{ question.stepSequence }}</b> - {{ questionTypes[question.type] }}</span
                        >
                        <input v-if="question.isDataMapped" type="text" class="ml-15 input-text readonly small-input" :placeholder="question.mapLabel" readonly />
                        <span v-if="question.isSkippable && question.type != 'SurveyCompletion'" class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2 pb-2 pl-5 pr-5">Optional</span>
                      </p>
                    </div>

                    <div class="dropleft col-md-2 p-0 text-right" style="white-space: nowrap; float: right" v-if="!hideEditBtn">
                      <img src="static/img/activity-configurator/row-settings.svg" id data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" alt class="settings-action-icon dropdown-toggle" />

                      <ul class="dropdown-menu action-dropdown-menu p-0 dropleft">
                        <!-- EDIT -->
                        <li class="settings-dropdown-item fs-12" :disabled="isDisabled" v-on:click="editQuestion(question, question.index)">
                          Edit
                        </li>

                        <!-- DUPLICATE -->
                        <li class="settings-dropdown-item fs-12" v-if="question.type != 'SurveyCompletion'" :disabled="isDisabled" v-on:click="checkDuplicate(question)">
                          Duplicate
                        </li>

                        <!-- BRANCHING -->
                        <li class="settings-dropdown-item fs-12" :disabled="isDisabled" v-on:click="addBranchingForQuestion(question, question.index)" v-if="question.type && applicableBranchingQues.includes(question.type)">
                          Branching
                        </li>

                        <!-- REORDER -->
                        <li class="settings-dropdown-item fs-12" v-if="question.type != 'SurveyCompletion'" :disabled="isDisabled" @click="reorderQuestion(indexRow, null)">
                          Reorder
                        </li>
                      </ul>
                    </div>
                    <div class="clearfix"></div>
                    <div class="col-md-12 p-0">
                      <div class="question-section">
                        <div :class="{ 'ml-30 mr-30': !hideEditBtn }">
                          <div class="answer-section">
                            <ActivityStepsView :question="question" />
                            <div class="option-section" v-if="question.type && question.type.toLowerCase() === 'valuepicker'">
                              <div class>
                                <input type="number" class="input-text readonly" placeholder readonly />
                              </div>
                            </div>
                            <div class="option-section" v-if="question.type && question.type.toLowerCase() === 'email'">
                              <div class>
                                <input type="email" class="input-text readonly" placeholder readonly />
                              </div>
                            </div>
                            <div class="option-section" v-if="question.type && question.type.toLowerCase() === 'location'">
                              <div class>
                                <input type="text" class="input-text readonly" placeholder readonly />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </template>
          <!-- If question does not have any columns -->
        </template>
      </div>
    </draggable>
    <!-- Notification Settings -->
    <div id="notificationModal" class="modal fade" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content p-30">
          <span class="close-dialog-icon"><i class="fa fa-times" data-dismiss="modal" aria-hidden="true"></i></span>
          <h5 class="text-center">
            Alert individuals on the study team based on an outcome of this question.
          </h5>
          <div class="modal-body ml-50 mr-50 mb-30 pt-10 pb-0">
            <select class="form-control type_select" v-model="selectedActivityQuestionForBranching.nextQuestionId">
              <option value="default" disabled>Select notification choice</option>
              <option v-for="(value, key) in notificationTypes" :value="key" :key="key">{{ value }} </option>
            </select>
          </div>
          <div class="modal-footer m-auto">
            <span class="branchingsavebtn"><span class="branchingbtntext">Save</span></span>
          </div>
        </div>
      </div>
    </div>
    <!-- Notification Settings -->

    <div id="branchingModal" class="modal fade" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content pl-15 pr-15" v-if="selectedActivityQuestionForBranching.type">
          <div class="border-none branchingstep">
            <span class="branchingstepcount">Step {{ selectedActivityQuestionForBranching.stepSequence }}</span>
            <span class="beanchinglogictext ml-5">Branch Logic</span>
          </div>
          <div class="branchingsteptitalname  ql-editor p-0 ml-20" v-html="selectedActivityQuestionForBranching.formattedBody"></div>
          <div v-if="selectedActivityQuestionForBranching.type.toLowerCase() === 'numberscale'">
            <div v-if="!selectedActivityQuestionForBranching.verticalScale" class="pull-left pl-20">
              {{ selectedActivityQuestionForBranching.minValueLabel }}
            </div>
            <div v-if="!selectedActivityQuestionForBranching.verticalScale" class="pull-right pr-20">
              {{ selectedActivityQuestionForBranching.maxValueLabel }}
            </div>
            <ds-slider
              :ref="'branchingSlider_' + selectedActivityQuestionForBranching.id"
              v-if="selectedActivityQuestionForBranching.partitions !== 0 && !selectedActivityQuestionForBranching.verticalScale"
              :value="selectedActivityQuestionForBranching.defaultPointerPosition == 'max' ? selectedActivityQuestionForBranching.maxValue : selectedActivityQuestionForBranching.minValue"
              :piecewise="true"
              direction="horizontal"
              tooltip="none"
              class="horizontal-vue-slider pt-25 ml-20 mr-20 horizontal-slider-process"
              :min="selectedActivityQuestionForBranching.minValue"
              :max="selectedActivityQuestionForBranching.maxValue"
              :disabled="true"
              :piecewiseLabel="true"
              :piecewiseStyle="piecewiseStyle"
              :interval="selectedActivityQuestionForBranching.partitions"
              :piecewiseActiveStyle="piecewiseActiveStyle"
              :labelActiveStyle="labelActiveStyle"
            ></ds-slider>
            <div v-if="selectedActivityQuestionForBranching.verticalScale" class="scaleLabels">
              {{ selectedActivityQuestionForBranching.maxValueLabel }}
            </div>
            <ds-slider
              :ref="'branchingSlider_' + selectedActivityQuestionForBranching.id"
              v-if="selectedActivityQuestionForBranching.partitions !== 0 && selectedActivityQuestionForBranching.verticalScale"
              :value="selectedActivityQuestionForBranching.defaultPointerPosition == 'max' ? selectedActivityQuestionForBranching.maxValue : selectedActivityQuestionForBranching.minValue"
              :piecewise="true"
              direction="vertical"
              tooltip="none"
              class="vertical-vue-slider pl-20 vertical-slider-process"
              width="1"
              :min="selectedActivityQuestionForBranching.minValue"
              :max="selectedActivityQuestionForBranching.maxValue"
              :disabled="true"
              :piecewiseLabel="true"
              :piecewiseStyle="piecewiseStyle"
              :interval="selectedActivityQuestionForBranching.partitions"
              :piecewiseActiveStyle="piecewiseActiveStyle"
              :labelActiveStyle="labelActiveStyle"
            ></ds-slider>
            <div v-if="selectedActivityQuestionForBranching.verticalScale" class="scaleLabels">
              {{ selectedActivityQuestionForBranching.minValueLabel }}
            </div>
          </div>
          <div class="option-section" v-if="selectedActivityQuestionForBranching.type == 'CustomScale'">
            <ds-slider
              :value="getDefaultPositionValueForCustomScale(selectedActivityQuestionForBranching)"
              v-if="selectedActivityQuestionForBranching.verticalScale"
              :ref="'branchingSlider_' + selectedActivityQuestionForBranching.id"
              :piecewise="true"
              width="2"
              direction="vertical"
              tooltip="none"
              class="vertical-vue-slider pt-25 ml-20 mr-20 vertical-slider-process"
              :data="selectedActivityQuestionForBranching.formattedLabels"
              :disabled="true"
              :piecewiseLabel="true"
              :piecewiseStyle="piecewiseStyle"
              :piecewiseActiveStyle="piecewiseActiveStyle"
              :labelActiveStyle="labelActiveStyle"
              style="text-align: -webkit-center"
            ></ds-slider>

            <ds-slider
              :value="getDefaultPositionValueForCustomScale(selectedActivityQuestionForBranching)"
              v-if="!selectedActivityQuestionForBranching.verticalScale"
              :ref="'branchingSlider_' + selectedActivityQuestionForBranching.id"
              :piecewise="true"
              width="1"
              direction="horizontal"
              tooltip="none"
              class="horizontal-vue-slider pt-20 ml-20 mr-20 horizontal-slider-process"
              :data="selectedActivityQuestionForBranching.formattedLabels"
              :disabled="true"
              :piecewiseLabel="true"
              :piecewiseStyle="piecewiseStyle"
              :piecewiseActiveStyle="piecewiseActiveStyle"
              :labelActiveStyle="labelActiveStyle"
              style="width: auto"
            ></ds-slider>
          </div>
          <div class="modal-body mt-10 pt-10 pb-0">
            <div class="branching_section" v-if="selectedActivityQuestionForBranching.type">
              <div class="row pb-5 pt-5">
                <div class="fs-12 p-0" v-if="selectedActivityQuestionForBranching.type.toLowerCase() === 'multichoice' && selectedActivityQuestionForBranching.multipleSelection">
                  Priority
                </div>
                <div class="col-md-1" v-if="selectedActivityQuestionForBranching.type.toLowerCase() === 'multichoice' && selectedActivityQuestionForBranching.multipleSelection">
                  <span v-b-popover.hover="'Rank the answers by priority. If multiple selections are provided the answer with the highest rank will trigger the action.'" class="fa fa-info-circle"></span>
                </div>
                <div class="col-md-5 fs-12 p-0" v-if="selectedActivityQuestionForBranching.type !== 'SurveyInstruction' && selectedActivityQuestionForBranching.type !== 'CustomScale' && selectedActivityQuestionForBranching.type.toLowerCase() !== 'numberscale'">
                  If the answer is:
                </div>
                <div class="col-md-4 fs-12 p-0" v-if="selectedActivityQuestionForBranching.type !== 'SurveyInstruction' && selectedActivityQuestionForBranching.type !== 'CustomScale' && selectedActivityQuestionForBranching.type.toLowerCase() !== 'numberscale'">
                  Skip to:
                </div>
                <div class="col-md-7 fs-12 p-0" v-if="selectedActivityQuestionForBranching.type == 'CustomScale' || selectedActivityQuestionForBranching.type.toLowerCase() === 'numberscale'">
                  If the answer is:
                </div>
                <div class="col-md-4 fs-12 p-0" v-if="selectedActivityQuestionForBranching.type == 'CustomScale' || selectedActivityQuestionForBranching.type.toLowerCase() === 'numberscale'">
                  Skip to:
                </div>

                <div class="col-md-1"></div>
              </div>
              <template v-if="selectedActivityQuestionForBranching.type && selectedActivityQuestionForBranching.type !== 'SurveyInstruction'">
                <div class="row pb-5 pt-5 branching-border" :key="index" v-for="(option, index) in selectedActivityQuestionForBranching.type.toLowerCase() == 'image' ? selectedActivityQuestionForBranching.languageImageOptions[0].options : selectedActivityQuestionForBranching.options">
                  <div class="col-md-2" v-if="multiChoiceTypes.indexOf(selectedActivityQuestionForBranching.type.toLowerCase()) >= 0 && selectedActivityQuestionForBranching.multipleSelection">
                    <span @click="changeOptionPriority(selectedActivityQuestionForBranching, option, 1)">
                      <img alt="arrow-down" class="rotate-180deg priority-img" src="static/img/arrow-down.png" />
                    </span>
                    <span class="priority-no">{{ option.priority }}</span>
                    <span @click="changeOptionPriority(selectedActivityQuestionForBranching, option, -1)">
                      <img alt="arrow-down" class="priority-img" src="static/img/arrow-down.png" />
                    </span>
                  </div>
                  <div class="col-md-5 p-0">
                    <div class="ql-editor p-0" v-if="selectedActivityQuestionForBranching.type && selectedActivityQuestionForBranching.type.toLowerCase() !== 'image'" v-html="option.formattedBody"></div>
                    <div v-else>
                      <img class="branching_image" :src="option.imageUrl" alt />
                    </div>
                  </div>
                  <div class="col-md-4 p-0">
                    <select class="form-control type_select" v-model="option.nextQuestion">
                      <option value="default" disabled>Select screen</option>
                      <option v-for="(question, index) in activityQuestions.filter(activityQuestion => activityQuestion.type != 'Section' && activityQuestion.id != selectedActivityQuestionForBranching.id)" :value="question.id" :key="index">
                        <span v-if="question.type !== 'SurveyCompletion'">{{ question.stepSequence }}</span>
                        <span v-else-if="question.subtype === 'custom'">Custom Completion</span>
                        <span v-else>End Activity</span>
                      </option>
                    </select>
                  </div>

                  <div class="col-md-1 p-0">
                    <button class="btn btn-link br-25 fs-12" @click="onClearOption(option)">
                      <img alt="delete" class="clearbranchimage" src="static/img/delete.svg" />
                    </button>
                  </div>
                </div>
              </template>
              <div v-if="selectedActivityQuestionForBranching.type === 'SurveyInstruction'">
                <div class="row pb-5 pt-5 branching-border">
                  <div class="col-md-4 p-0">
                    <select class="form-control type_select" v-model="selectedActivityQuestionForBranching.nextQuestionId">
                      <option value="default" disabled>Select screen</option>
                      <option v-for="(question, index) in activityQuestions.filter(activityQuestion => activityQuestion.type != 'Section' && activityQuestion.id != selectedActivityQuestionForBranching.id)" :value="question.id" :key="index">
                        <span v-if="question.type !== 'SurveyCompletion'">{{ question.stepSequence }}</span>
                        <span v-else-if="question.subtype === 'custom'">Custom Completion</span>
                        <span v-else>End Activity</span>
                      </option>
                    </select>
                  </div>
                  <div class="col-md-1 p-0">
                    <button class="btn btn-link br-25 fs-12" v-on:click="selectedActivityQuestionForBranching.nextQuestionId = 'default'">
                      <img alt="delete" class="clearbranchimage" src="static/img/delete.svg" />
                    </button>
                  </div>
                </div>
              </div>
              <!-- number scale start-->
              <template v-if="selectedActivityQuestionForBranching.type.toLowerCase() === 'numberscale'">
                <div v-for="(branchingoption, index) in selectedActivityQuestionForBranching.branchingOptions" :key="index">
                  <div class="row pb-5 pt-5 branching-border">
                    <div class="col-md-3 p-0">
                      <input type="radio" :id="'singlevalue' + index" v-model="branchingoption.type" @change="onChangeRadioButton(branchingoption.type, index)" :name="'numberscalebranchingtype' + index" value="single" />
                      <label :for="'singlevalue' + index" class="fs-10 ml-5">Single value</label>
                      <div class="clearfix"></div>
                      <select class="branching-select-option" v-model="branchingoption.singleValue" :disabled="branchingoption.type != 'single'">
                        <option v-for="value in allintervalForNumberscale" :value="value" :key="value">
                          {{ value }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-4 p-0">
                      <input type="radio" :id="'setrange' + index" v-model="branchingoption.type" @change="onChangeRadioButton(branchingoption.type, index)" :name="'numberscalebranchingtype' + index" value="range" />
                      <label :for="'setrange' + index" class="fs-10 ml-5">Set a range</label>
                      <div class="clearfix"></div>
                      <select class="branching-select-option" v-model="branchingoption.startValue" :disabled="branchingoption.type != 'range'">
                        <option v-for="(value, index) in allintervalForNumberscale" :value="value" :disabled="index == allintervalForNumberscale.length - 1" :key="value">
                          {{ value }}
                        </option>
                      </select>
                      to
                      <select class="branching-select-option" v-model="branchingoption.endValue" :disabled="branchingoption.type != 'range'">
                        <option v-for="(value, index) in allintervalForNumberscale" :value="value" :disabled="index == 0" :key="value">
                          {{ value }}
                        </option>
                      </select>
                    </div>

                    <div class="col-md-4 p-0">
                      <select class="form-control type_select mt-10" v-model="branchingoption.nextQuestionId">
                        <option value="default" disabled>Select screen</option>
                        <option v-for="(question, index) in activityQuestions.filter(activityQuestion => activityQuestion.type != 'Section' && activityQuestion.id != selectedActivityQuestionForBranching.id)" :value="question.id" :key="index">
                          <span v-if="question.type !== 'SurveyCompletion'">{{ question.stepSequence }}</span>
                          <span v-else-if="question.subtype === 'custom'">Custom Completion</span>
                          <span v-else>End Activity</span>
                        </option>
                      </select>
                    </div>
                    <div class="col-md-1 p-0">
                      <button class="btn btn-link br-25 fs-12 mt-10" @click="onDeleteScaleBranchingQuestion(index)">
                        <img alt="delete" class="clearbranchimage" src="static/img/delete.svg" />
                      </button>
                    </div>
                  </div>
                </div>
              </template>
              <div class="branching-border" v-if="selectedActivityQuestionForBranching.type.toLowerCase() === 'numberscale'">
                <span class="Add_another_branch mt-5" type="button" @click="addAnotherBranch">Add another branch</span>
              </div>
              <!--number scale end-->

              <!--custom scale start-->
              <template v-if="selectedActivityQuestionForBranching.type.toLowerCase() === 'customscale'">
                <div v-for="(branchingoption, index) in selectedActivityQuestionForBranching.branchingOptions" :key="index">
                  <div class="row pb-5 pt-5 branching-border">
                    <div class="col-md-3 p-0">
                      <input type="radio" :id="'singlevalue' + index" v-model="branchingoption.type" @change="onChangeRadioButton(branchingoption.type, index)" :name="'customscalebranchingtype' + index" value="single" />
                      <label for="singlevalue" class="fs-10 ml-5">Single value</label>
                      <div class="clearfix"></div>
                      <select class="branching-select-option" v-model="branchingoption.singleValue" :disabled="branchingoption.type != 'single'">
                        <option v-for="(scaleLabels, index) in selectedActivityQuestionForBranching.labels" :key="index" :value="scaleLabels">
                          {{ scaleLabels }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-4 p-0">
                      <input type="radio" :id="'setrange' + index" v-model="branchingoption.type" @change="onChangeRadioButton(branchingoption.type, index)" :name="'customscalebranchingtype' + index" value="range" />
                      <label for="setrange" class="fs-10 ml-5">Set a range</label>
                      <div class="clearfix"></div>
                      <select class="branching-select-option" v-model="branchingoption.startValue" :disabled="branchingoption.type != 'range'">
                        <option v-for="(scaleLabels, index) in selectedActivityQuestionForBranching.labels" :key="index" :disabled="index == selectedActivityQuestionForBranching.labels.length - 1" :value="scaleLabels">
                          {{ scaleLabels }}
                        </option>
                      </select>
                      to
                      <select class="branching-select-option" v-model="branchingoption.endValue" :disabled="branchingoption.type != 'range'">
                        <option v-for="(scaleLabels, index) in selectedActivityQuestionForBranching.labels" :key="index" :disabled="index == 0" :value="scaleLabels">
                          {{ scaleLabels }}
                        </option>
                      </select>
                    </div>

                    <div class="col-md-4 p-0">
                      <select class="form-control type_select mt-10" v-model="branchingoption.nextQuestionId">
                        <option value="default" disabled>Select screen</option>
                        <option v-for="(question, index) in activityQuestions.filter(activityQuestion => activityQuestion.type != 'Section' && activityQuestion.id != selectedActivityQuestionForBranching.id)" :value="question.id" :key="index">
                          <span v-if="question.type !== 'SurveyCompletion'">{{ question.stepSequence }}</span>
                          <span v-else-if="question.subtype === 'custom'">Custom Completion</span>
                          <span v-else>End Activity</span>
                        </option>
                      </select>
                    </div>
                    <div class="col-md-1 p-0">
                      <button class="btn btn-link br-25 fs-12 mt-10" @click="onDeleteScaleBranchingQuestion(index)">
                        <img alt="delete" class="clearbranchimage" src="static/img/delete.svg" />
                      </button>
                    </div>
                  </div>
                </div>
              </template>
              <div class="branching-border" v-if="selectedActivityQuestionForBranching.type.toLowerCase() === 'customscale'">
                <span class="Add_another_branch mt-5" type="button" @click="addAnotherBranch">Add another branch</span>
              </div>
              <!--custom scale end-->
            </div>
          </div>
          <div class="modal-footer m-auto">
            <span class="cancelbranchingbtn" data-dismiss="modal">Cancel</span>
            <span class="branchingsavebtn" v-on:click="saveBranchingForQuestion(selectedActivityQuestionForBranching)">
              <span class="branchingbtntext">Save</span>
            </span>
          </div>
        </div>
      </div>
    </div>

    <!--Reorder Modal -->
    <b-modal id="reorderingModal" hide-header hide-footer ref="reorderingModal" @hidden="resetReorderObj" @shown="setFocusOnReorderQuestionTo" :no-close-on-esc="noCloseOnBackdrop" :no-close-on-backdrop="noCloseOnBackdrop">
      <template v-slot:modal-header>
        <div class="mb-20">
          <span class="modal-title">Step {{ reorderQuestionIndex }}</span>
          <button type="button" class="close ml-30" @click="closeReorderModal()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </template>

      <div class="modal-body-cntr">
        <strong>Move to position</strong>
        <input type="text" v-model="reorderQuestionTo" tabindex="0" ref="reorderQuestionTo" class="form-control d-inline w-50 ml-10" v-on:input="setMoveToPosition(reorderQuestionTo)" />
        <div v-if="reorderError !== false && reorderError !== true" class="invalid-feedback">
          {{ reorderError }}
        </div>
      </div>
      <div class="modal-footer justify-content-center pb-3">
        <button class="btn btn-primary move-btn" :disabled="reorderError || reorderError != ''" @click="reOrderCheckBranching">
          Move
        </button>
      </div>
    </b-modal>
    <!-- Reorder modal ends -->
    <branchingSetupModal v-if="activityQuestions.length && activityQuestions" :activityQuestions="skiptToQuestionOptions" :selectedQuestionForBranching="selectedActivityQuestionForBranching" :questionTypes="questionTypes" @saveBranching="saveBranching" ref="branchingSetupModal" />
  </div>
</template>

<script>
import toastr from "toastr";
import _ from "lodash";
import draggable from "vuedraggable";
import swal from "sweetalert2";
import dsSlider from "../../lib/ds-slider-component";
import addEditQuestion from "./activity-add-edit-question";
import sampleQuestionObj from "../survey-builder/surveyQuestion.json";
import sectionJSON from "@/constants/activity-library-and-configurator-component/activityGroup";
import * as activityService from "@/components/services/activity-service";

// STEPS
import ActivityStepsView from "@/components/activity-library/activity-steps/activity-steps-view";
import branchingSetupModal from "@/components/activity-library/branching-setup-modal";
import { BranchingHelper } from "@/components/activity-library/branching-helper";
export default {
  name: "activity-read-only-question",
  data() {
    return {
      selectedActivityQuestion: { id: null },
      selectedActivityQuestionForBranching: { id: null },
      activityId: null,
      activityQuestions: [],
      activityRows: [],
      activityRowsArray: null,
      draggedToRow: null,
      editColumnQuesion: undefined,
      sectionModificationMode: "",
      pointerInfoDiv: false,
      piecewiseActiveStyle: {
        backgroundColor: "#3498db"
      },
      labelActiveStyle: {
        color: "#3498db"
      },
      piecewiseStyle: {
        backgroundColor: "#ccc",
        visibility: "visible",
        width: "12px",
        height: "12px"
      },
      isDisabled: false,
      reorderQuestionIndex: null,
      reorderQuestionColumn: null,
      reorderQuestionRow: null,
      reorderQuestionTo: null,
      noCloseOnBackdrop: true,
      reorderError: true,
      defaultBranchingOptions: {
        isSingleValue: true,
        singleValue: "",
        startValue: "",
        endValue: "",
        type: "single",
        nextQuestionId: "default",
        error: ""
      },
      multiChoiceTypes: ["multichoice", "image"],
      questionTypes: {
        SurveyInstruction: "Instruction screen",
        CustomScale: "Custom scale",
        DateTime: "Date / Time",
        DropDown: "Drop-down",
        GPSkin: "gpskin Barrier device scan",
        ImageCapture: "Image capture",
        Image: "Image choice",
        Index: "Index",
        Log: "Log Entry",
        Measurements: "Measurements",
        MedicationSelector: "Medication Selector",
        MultiChoice: "Multiple choice",
        Number: "Number Response",
        NumberScale: "Number Scale",
        Text: "Text Response",
        ValidatedEntry: "Validated Entry",
        VAS: "Visual analog scale",
        Boolean: "Yes or No",
        WongBaker: "Wong-Baker FACES Pain Rating Scale",
        AudioRecording: "Audio Recording",
        VideoRecording: "Video Recording",
        SurveyCompletion: "Custom Completion Screen",
        SkinAnalyser: "Redness and Dryness Assessment"
      },
      notificationTypes: {
        noAnswer: "If no answer is provided",
        anyAnswer: "If any answer is provided",
        specificAnswer: "If a specific answer is provided",
        minMaxAnswer: "If value is above/below set threshold"
      },
      applicableBranchingQues: ["MultiChoice", "Boolean", "Image", "SurveyInstruction", "CustomScale", "NumberScale", "DropDown", "Number", "Text"],
      skiptToQuestionOptions: null,
      BranchingHelper: new BranchingHelper()
    };
  },
  props: ["activityData", "hideEditBtn", "isGroupScoringInEditMode", "activeEditGroup", "batchDeleteQuestions", "showDeleteButton"],
  components: {
    dsSlider,
    addEditQuestion,
    draggable,
    ActivityStepsView,
    branchingSetupModal
  },
  mounted() {
    this.activityId = this.$route.params.activityId;
    this.revisionId = this.$route.params.revisionId;
    this.studyId = this.$route.params.studyId;
  },
  computed: {
    selectedActivityQuestionChange() {
      return this.$store.getters.getActivitySelectedQuestion;
    },
    questions() {
      return this.$store.getters.getActivityQuestionsData;
    },
    draggable() {
      let drag = false;
      if (this.hideEditBtn) {
        return true;
      }
      this.activityQuestions.forEach(item => {
        if (item.id === this.selectedActivityQuestion.id) {
          drag = true;
        }
      });
      return drag;
    },
    duplicateQuestionSaved() {
      return this.$store.getters.getNewActivityQuestion;
    },
    getLastModifiedActivityQuestion() {
      return this.$store.getters.getLastModifiedActivityQuestion;
    },
    allintervalForNumberscale() {
      if (!this.selectedActivityQuestionForBranching) {
        return [];
      }
      if (!this.selectedActivityQuestionForBranching.type.toLowerCase() === "numberscale") {
        return [];
      }
      const { minValue, maxValue, intervals } = this.selectedActivityQuestionForBranching;
      return this.getIntervalValues(minValue, maxValue, intervals);
    }
  },
  watch: {
    activityQuestions: {
      deep: true,
      handler(questions) {
        this.prepareSkipToQuestionOptions(questions, this.selectedActivityQuestionForBranching);
      }
    },
    selectedActivityQuestionForBranching: {
      deep: true,
      handler(selectedQuesForBranching) {
        this.prepareSkipToQuestionOptions(this.activityQuestions, selectedQuesForBranching);
      }
    },
    activityData: {
      deep: true,
      handler(val) {
        if (this.activityRowsArray !== null && this.activityRowsArray !== val.rows) {
          this.activityRowsArray = val.rows;
          this.activityRows = activityService.getColumnsArrayEditMode(val.questions, val.rows);
          this.activityQuestions = val.questions;
        } else if (this.activityRowsArray == null) {
          this.activityRowsArray = val.rows;
          this.activityRows = activityService.getColumnsArrayEditMode(val.questions, val.rows);
          this.activityQuestions = val.questions;
        } else if (JSON.stringify(this.activityRowsArray) === JSON.stringify(val.rows)) {
          //update step number in branching after reorder
          this.activityQuestions = val.questions;
        }
      }
    },
    activeEditGroup: {
      handler() {}
    },
    selectedActivityQuestionChange: {
      handler(val) {
        let deleteButtonFlag = this.showDeleteButton;
        deleteButtonFlag = false;
        this.$emit("update-delete-flag", deleteButtonFlag);
        this.selectedActivityQuestion = val;
        if (this.selectedActivityQuestion.type == "DateTime") {
          if (this.selectedActivityQuestion.useStartCurrentDate) {
            this.selectedActivityQuestion.startDate = null;
          }
          if (this.selectedActivityQuestion.useEndCurrentDate) {
            this.selectedActivityQuestion.endDate = null;
          }
          if (this.selectedActivityQuestion.useTargetCurrentDate) {
            this.selectedActivityQuestion.targetDate = null;
          }
        }
        if (this.selectedActivityQuestion.type == "CustomScale") {
          if (!this.selectedActivityQuestion.scores) {
            this.selectedActivityQuestion.scores = [];
          }
        }
        if (val && val.type === "Section" && !val.hasOwnProperty("id")) {
          return;
        }
        if (!(val && val.hasOwnProperty && val.hasOwnProperty("id") && val.id)) {
          this.$emit("update:activeEditGroup", null);
        }
      }
    },
    duplicateQuestionSaved(val) {
      if (!val) {
        if (this.getLastModifiedActivityQuestion && this.getLastModifiedActivityQuestion.type != "Section") {
        }
        //Enable all the buttons
        this.isDisabled = false;
      }
    },
    reorderQuestionTo(newVal) {
      if (newVal) {
        const re = /[^0-9]/;
        const sanitizedValue = newVal.replace(re, "");
        this.$set(this, "reorderQuestionTo", sanitizedValue);

        if (activityService.isColumnReorderPossible(this.activityQuestions, this.activityRows, newVal) && sanitizedValue !== "") {
          this.reorderError = false;
        } else {
          this.reorderError = "Please enter a valid position number";
        }
      }
    }
  },
  methods: {
    prepareSkipToQuestionOptions(questions, selectedActivityQuestionForBranching) {
      this.skiptToQuestionOptions = _.filter(questions, function(o) {
        return o.type != "Section" && o.id != selectedActivityQuestionForBranching.id;
      });
    },
    saveBranching(selectedQuestion) {
      this.selectedActivityQuestionForBranching = selectedQuestion;
      this.saveBranchingForQuestion(this.selectedActivityQuestionForBranching);
    },
    updateActivityData(activityData) {
      this.$api.updateActivity(this.activityId, _.cloneDeep(activityData)).then(() => {
        this.$toastr.success("Activity updated successfully");
      });
    },
    setMoveToPosition(value) {
      if (value.length == 0) {
        this.reorderError = true;
      }
    },
    onDeleteScaleBranchingQuestion(index) {
      if (this.selectedActivityQuestionForBranching.branchingOptions.length > 1) {
        this.selectedActivityQuestionForBranching.branchingOptions.splice(index, 1);
      } else {
        this.selectedActivityQuestionForBranching.branchingOptions = [];
        this.selectedActivityQuestionForBranching.branchingOptions.push({
          ...this.defaultBranchingOptions
        });
      }
    },
    addAnotherBranch() {
      this.selectedActivityQuestionForBranching.branchingOptions.push({
        ...this.defaultBranchingOptions
      });
    },
    onChangeRadioButton(type, index) {
      if(type === "single") {
        this.selectedActivityQuestionForBranching.branchingOptions[index].startValue = ""
        this.selectedActivityQuestionForBranching.branchingOptions[index].endValue = ""
      } else if(type === "range") {
        this.selectedActivityQuestionForBranching.branchingOptions[index].singleValue = ""
      }
    },
    getIntervalValues(min, max, interval) {
      const gap = (max - min) / interval;
      if (!Number.isInteger(gap)) {
        this.$toastr.error("Gap should be a whole number");
        return;
      }
      const allValues = [];
      for (let i = 0; i <= interval; i++) {
        const indexGap = i * gap;
        allValues.push(min + indexGap);
      }
      return allValues;
    },
    onClearOption(option) {
      option.nextQuestion = "default";
      if (option.hasOwnProperty("priority")) {
        option.priority = 0;
      }
    },
    changeOptionPriority(question, option, direction) {
      const stepOptions = question.options || question.languageImageOptions[0].options;
      const maxPriority = stepOptions.length;
      if (option.priority == maxPriority && direction == 1) {
        return;
      }
      if (option.priority == 0 && direction == -1) {
        return;
      }
      if (option.nextQuestion === "default") {
        return;
      }
      option.priority += direction;
    },
    editColumnQuestion(question) {
      if (!question) {
        return;
      }
      this.editColumnQuesion = question.id;
      this.selectedActivityQuestion = _.cloneDeep(question);
      if (this.selectedActivityQuestion.type === "MultiChoice" && !this.selectedActivityQuestion.bodyImages) {
        this.selectedActivityQuestion.bodyImages = [{ sequence: 1, imageUrl: null, imageId: null }];
      }
      this.$store.dispatch("selectedActivityQuestionAction", _.cloneDeep(this.selectedActivityQuestion));
      this.$emit("editedEvent", question.stepSequence - 1);
      if (question && question.type === "Section") {
        this.$emit("onSectionAddEdit", question);
      }
    },
    editQuestion(question, index) {
      if (!question) {
        return;
      }
      this.selectedActivityQuestion = _.cloneDeep(question);
      if (this.selectedActivityQuestion.type === "MultiChoice" && !this.selectedActivityQuestion.bodyImages) {
        this.selectedActivityQuestion.bodyImages = [{ sequence: 1, imageUrl: null, imageId: null }];
      }
      this.$store.dispatch("selectedActivityQuestionAction", _.cloneDeep(this.selectedActivityQuestion));
      this.$emit("editedEvent", index);
      if (question && question.type === "Section") {
        this.$emit("onSectionAddEdit", question);
      }
    },
    addBranchingForQuestion(question, index) {
      if (!this.BranchingHelper.canConfigureBranching(question, this.activityQuestions)) {
        return;
      }

      if (question.type && question.type.toLowerCase() !== "image") {
        _.forEach(question.options, value => {
          value.nextQuestion = value.nextQuestion ? value.nextQuestion : "default";
        });
      } else {
        _.forEach(question.languageImageOptions[0].options, value => {
          value.nextQuestion = value.nextQuestion ? value.nextQuestion : "default";
          value.priority = value.priority || 0;
        });
      }

      question.nextQuestionId = question.nextQuestionId ? question.nextQuestionId : "default";
      question.index = index;
      this.selectedActivityQuestionForBranching = _.cloneDeep(question);
      if (this.selectedActivityQuestionForBranching.type == "NumberScale" || this.selectedActivityQuestionForBranching.type == "CustomScale") {
        setTimeout(() => {
          const ref = "branchingSlider_" + question.id;
          this.$refs[ref] && this.$refs[ref].refresh();
        }, 700);

        if (!this.selectedActivityQuestionForBranching.branchingOptions) {
          this.selectedActivityQuestionForBranching.branchingOptions = [];
        }
        if (this.selectedActivityQuestionForBranching.branchingOptions.length === 0) {
          this.selectedActivityQuestionForBranching.branchingOptions.push({
            ...this.defaultBranchingOptions
          });
        }
      }

      if (this.selectedActivityQuestionForBranching.type == "Number" && (!this.selectedActivityQuestionForBranching.branchingOptions || this.selectedActivityQuestionForBranching.branchingOptions.length == 0)) {
        this.selectedActivityQuestionForBranching.branchingOptions = [
          {
            startValue: "",
            endValue: "",
            nextQuestionId: "",
            error: []
          }
        ];
      }

      if (this.selectedActivityQuestionForBranching.type == "MultiChoice" && this.selectedActivityQuestionForBranching.multipleSelection && (!this.selectedActivityQuestionForBranching.branchingOptions || this.selectedActivityQuestionForBranching.branchingOptions.length == 0)) {
        if (!this.selectedActivityQuestionForBranching.branchingType) {
          this.selectedActivityQuestionForBranching.branchingType = "advance";
        }
        this.selectedActivityQuestionForBranching.branchingOptions = [
          {
            optionIds: [],
            nextQuestionId: "",
            error: [],
            chipsLimitBy: 6
          }
        ];
      }

      //Open new branching setup modal for questions introduced in TUR-145553
      const newQuesApplicableforBranching = ["Number", "Text", "MultiChoice"];

      if (newQuesApplicableforBranching.includes(this.selectedActivityQuestionForBranching.type)) {
        if (!this.selectedActivityQuestionForBranching.branchingType) {
          this.selectedActivityQuestionForBranching.branchingType = "normal";
        }
        //Lets open old modal for multiple choice single selection
        if (this.selectedActivityQuestionForBranching.type == "MultiChoice" && !this.selectedActivityQuestionForBranching.multipleSelection) {
          window.$("#branchingModal").modal({
            backdrop: "static"
          });
        } else {
          this.$refs.branchingSetupModal.show();
        }
      } else {
        window.$("#branchingModal").modal({
          backdrop: "static"
        });
      }
    },
    saveBranchingForQuestion() {
      if (this.selectedActivityQuestionForBranching.subType && this.selectedActivityQuestionForBranching.subType.toLowerCase() === "multichoice" && this.selectedActivityQuestionForBranching.subType.toLowerCase() === "multi") {
        const allPriority = this.selectedActivityQuestionForBranching.options.filter(option => option.priority != 0).map(option => option.priority);
        if (_.uniq(allPriority).length != allPriority.length) {
          this.$toastr.error("All the priorities should be unique.");
          return;
        }
      }
      if (this.selectedActivityQuestionForBranching.type == "NumberScale") {
        let hasError, errorText;
        this.selectedActivityQuestionForBranching.branchingOptions.forEach(row => {
          if (row.type == "range") {
            if ((!row.startValue && row.startValue !== 0) || (!row.endValue && row.endValue !== 0)) {
              hasError = true;
              errorText = "Please populate all required fields";
            } else if (row.startValue > row.endValue) {
              hasError = true;
              errorText = "Start value can not be greater than end value";
            } else if (row.startValue == row.endValue) {
              hasError = true;
              errorText = "Start value can not be same as end value";
            } else if (row.nextQuestionId == "default") {
              hasError = true;
              errorText = "Please populate all required fields";
            }
          } else {
            if (!row.singleValue && row.singleValue !== 0) {
              hasError = true;
              errorText = "Please populate all required fields";
            } else if (row.nextQuestionId == "default") {
              hasError = true;
              errorText = "Please populate all required fields";
            }
          }
        });
        if (hasError) {
          this.$toastr.error(errorText);
          return;
        }
      }
      if (this.selectedActivityQuestionForBranching.type == "CustomScale") {
        let hasError, errorText;
        this.selectedActivityQuestionForBranching.branchingOptions.forEach(row => {
          if (row.type == "range") {
            if ((!row.startValue && row.startValue !== 0) || (!row.endValue && row.endValue !== 0)) {
              hasError = true;
              errorText = "Please populate all required fields";
            } else if(row.nextQuestionId === "default") {
              hasError = true;
              errorText = "Please populate all required fields";
            }
          } else {
            if (!row.singleValue && row.singleValue !== 0) {
              hasError = true;
              errorText = "Please populate all required fields";
            } else if(row.nextQuestionId === "default") {
              hasError = true;
              errorText = "Please populate all required fields";
            }
          }
        });
        if (hasError) {
          this.$toastr.error(errorText);
          return;
        }
      }

      this.reOrderSteps();
      this.$store.dispatch("addActivityQuestionAction", this.selectedActivityQuestionForBranching);
      window.$("#branchingModal").modal("hide");
    },
    deleteQuestion(question) {
      this.$api.deleteActivityQuestionFact(this.activityId, question.id).then(
        () => {
          toastr.success("Step deleted successfully");
          const questionIndex = _.findIndex(this.activityQuestions, ["id", question.id]);
          this.activityQuestions.splice(questionIndex, 1);
        },
        error => {
          this.errorMsg = error.body ? error.body.message : "Error while deleting the step";
          toastr.error(this.errorMsg);
        }
      );
    },
    isQuestionPartOfBranchingLogic(inputQuestion) {
      if (this.activityData.questions && this.activityData.questions.length > 0) {
        for (const questionIndex in this.activityData.questions) {
          const question = this.activityData.questions[questionIndex];
          if (question.branchingConfigured == true) {
            if (question.nextQuestionId && question.nextQuestionId == inputQuestion.id) {
              return true;
            }
            if (question.branchingOptions && question.branchingOptions.length > 0) {
              for (let i = 0; i < question.branchingOptions.length; i++) {
                if (question.branchingOptions[i].nextQuestionId && question.branchingOptions[i].nextQuestionId == inputQuestion.id) {
                  return true;
                }
              }
            }
            if (question.type.toLowerCase() !== "image" && question.options) {
              for (let i = 0; i < question.options.length; i++) {
                if (question.options[i].nextQuestion && question.options[i].nextQuestion == inputQuestion.id) {
                  return true;
                }
              }
            } else {
              if (question.languageImageOptions && question.languageImageOptions[0] && question.languageImageOptions[0].options) {
                for (let i = 0; i < question.languageImageOptions[0].options.length; i++) {
                  if (question.languageImageOptions[0].options[i].nextQuestion && question.languageImageOptions[0].options[i].nextQuestion == inputQuestion.id) {
                    return true;
                  }
                }
              }
            }
          }
        }
      }
      return false;
    },
    changeColumn(row, col, split) {
      let updateQuestions = false;
      const activities = this.activityRows;

      switch (split) {
        case 1:
          if (activities[row]["columns"].length == 1) {
            const copyChildToParent = Object.assign({}, activities[row]["columns"][col]);
            copyChildToParent["columns"] = [];
            copyChildToParent["columnCount"] = 0;

            activities[row] = copyChildToParent;
            updateQuestions = true;
          } else if (activities[row]["columns"].length == 2) {
            const copyChildToParent = Object.assign({}, activities[row]["columns"][col]);
            copyChildToParent["columns"] = [];
            copyChildToParent["columnCount"] = 0;
            activities[row]["columns"].splice(col, 1);

            /** If Columns after removing toMove question equal to 1 */
            if (activities[row]["columns"].length == 1) {
              const copyInnerChildToParent = Object.assign({}, activities[row]["columns"][0]);
              activities[row] = copyInnerChildToParent;
              activities[row]["columns"] = [];
              activities[row]["columnCount"] = 0;

              updateQuestions = true;
            }

            activities.splice(row, 0, copyChildToParent);
          } else if (activities[row]["columns"].length == 3) {
            const copyChildToParent = Object.assign({}, activities[row]["columns"][col]);
            copyChildToParent["columns"] = [];
            copyChildToParent["columnCount"] = 0;
            activities[row]["columns"].splice(col, 1);

            /** If Columns after removing toMove question equal to 1 */
            if (activities[row]["columns"].length == 1) {
              const copyInnerChildToParent = Object.assign({}, activities[row]["columns"][0]);
              activities[row] = copyInnerChildToParent;
              activities[row]["columns"] = [];
              activities[row]["columnCount"] = 0;

              updateQuestions = true;
            }

            activities.splice(row, 0, copyChildToParent);
          }
          break;
        case 2:
          activities[row]["columnCount"] = split;
          /** If Row has columns already */
          if (activities[row]["columns"].length == 0) {
            const copyParentToChild = Object.assign({}, activities[row]);
            copyParentToChild["columns"] = [];
            copyParentToChild["columnCount"] = 0;

            activities[row]["columns"].push(copyParentToChild);
          }
          break;
        case 3:
          activities[row]["columnCount"] = split;
          /** If Row has columns already */
          if (activities[row]["columns"].length == 0) {
            const copyParentToChild = Object.assign({}, activities[row]);
            copyParentToChild["columns"] = [];
            copyParentToChild["columnCount"] = 0;

            activities[row]["columns"].push(copyParentToChild);
          }
          break;
      }

      this.activityRows = activities;
      if (split == 1 && updateQuestions) {
        this.reOrderSteps();
      }
      this.$forceUpdate();
    },
    async checkMove(event) {
      /** If Branching is Configured */
      if (event.draggedContext.futureIndex == event.draggedContext.index && event.to.dataset.indexrow == event.from.dataset.indexrow) {
        return false;
      }
      let branchingQuestions = activityService.isBranchingConfigured(this.activityRows);
      if (branchingQuestions.length > 0) {
        swal({
          title: "Please be advised that that this activity has branching logic setup. We suggest you review and revise it as needed. Would you like to continue?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#b8c7ce",
          cancelButtonColor: "#34537d",
          confirmButtonText: "Cancel",
          cancelButtonText: "Yes"
        }).then(({ dismiss }) => {
          if (dismiss === "cancel") {
            if (event.to.dataset.hasOwnProperty("indexrow")) {
              const canBeDragged = activityService.isColumnDraggableConditionFulfilled(this.activityRows, event);
              if (!canBeDragged) {
                toastr.error("Step cannot be moved as this column is already full.");
              } else {
                const thisItem = _.cloneDeep(event.draggedContext.element);
                /** If Row has only 1 Column */
                if (this.activityRows[event.from.dataset.indexrow].columns.length == 1) {
                  this.activityRows.splice(event.from.dataset.indexrow, 1);
                } else {
                  this.activityRows[event.from.dataset.indexrow].columns.splice(event.draggedContext.index, 1);
                }

                this.activityRows[event.to.dataset.indexrow].columns.splice(event.draggedContext.futureIndex, 0, thisItem);
                this.reOrderSteps();
              }

              return canBeDragged;
            } else if (event.draggedContext.element.type !== "Section") {
              const thisItem = _.cloneDeep(this.activityRows[event.draggedContext.index]);
              this.activityRows.splice(event.draggedContext.index, 1);
              this.activityRows.splice(event.draggedContext.futureIndex, 0, thisItem);
              this.reOrderSteps();
            }
          } else {
            return false;
          }
        });
        return false;
      } else if (event.to.dataset.hasOwnProperty("indexrow")) {
        const canBeDragged = activityService.isColumnDraggableConditionFulfilled(this.activityRows, event);
        if (!canBeDragged) {
          toastr.error("Step cannot be moved as this column is already full.");
        }

        return canBeDragged;
      } else if (event.draggedContext.element.type !== "Section") {
        /** If Step is not equal to Section */
        return true;
      }
    },
    onDragStart(event) {
      delete this.activityRows[event.to.dataset.indexrow]["columns"][event.newIndex];
    },
    onDragEnd(event) {
      if (event.from !== event.to) {
        if (this.activityRows[event.from.dataset.indexrow]["columns"].length == 0) {
          this.activityRows.splice(event.from.dataset.indexrow, 1);
        } else if (this.activityRows[event.from.dataset.indexrow]["columns"].length > 0) {
          this.activityRows[event.from.dataset.indexrow]["columnCount"] = this.activityRows[event.from.dataset.indexrow]["columns"].length;
        }
        this.reOrderSteps();
      }

      this.$forceUpdate();
    },
    reOrderSteps() {
      const reOrderReponse = activityService.columnsReOrder(this.activityQuestions, this.activityRows);
      this.activityRows = reOrderReponse.activityRows;
      this.activityData.rows = reOrderReponse.rows;
      this.activityQuestions = reOrderReponse.questions;
      this.activityData.questions = reOrderReponse.questions;

      if (this.activityRowsArray !== reOrderReponse.rows) {
        this.activityRowsArray = _.cloneDeep(reOrderReponse.rows);
        this.$store.dispatch("setActivityRowsAction", this.activityData);
      }
      this.$store.dispatch("activityQuestionsAction", reOrderReponse.questions);
      return;
      /** Re-Numbering steps logic */
    },
    onDragQuestionColumns(event) {
      /** When Column is added */
      if (event.hasOwnProperty("added")) {
        let colIndex = null;
        let rowIndex = this.activityRows.findIndex(e => e.id == event.added.element.id);
        if (rowIndex == -1) {
          this.activityRows.forEach((e, i) => {
            if (e.columns.length > 0 && (colIndex == null || colIndex == -1)) {
              colIndex = e.columns.findIndex(ie => ie.id == event.added.element.id);
              rowIndex = i;
            }
          });
        }

        if (rowIndex > -1 && this.activityRows[rowIndex].columns.length == 0) {
          this.activityRows.splice(rowIndex, 1);
        } else if (rowIndex > -1) {
          this.activityRows[rowIndex]["columnCount"] = this.activityRows[rowIndex]["columns"].length;
        }
      }
      /** When Column is added */

      /** When Column is removed */
      if (event.hasOwnProperty("removed")) {
        let colIndex = null;
        let rowIndex = this.activityRows.findIndex(e => e.id == event.removed.element.id);
        if (rowIndex == -1) {
          this.activityRows.forEach((e, i) => {
            if (e.columns.length > 0 && (colIndex == null || colIndex == -1)) {
              colIndex = e.columns.findIndex(ie => ie.id == event.removed.element.id);
              rowIndex = i;
            }
          });
        }

        if (rowIndex > -1 && this.activityRows[rowIndex].columns.length == 0) {
        } else if (rowIndex > -1) {
          this.activityRows[rowIndex]["columnCount"] = this.activityRows[rowIndex]["columns"].length;
        }
      }
      /** When Column is removed */

      this.reOrderSteps();
    },
    onDragQuestion() {
      this.reOrderSteps();
    },
    duplicateQuestion(questionObjOld) {
      let questionObj = questionObjOld;
      //Lets disbale the Duplicate/Edit/Branching button
      this.isDisabled = true;

      //First of all create a sample question object
      const questionSample = _.cloneDeep(JSON.parse(JSON.stringify(sampleQuestionObj)));

      const isBranchingConfigured = questionObj.branchingConfigured;

      //Remove the keys that we do not want to override/keep
      questionObj = _.omit(questionObj, ["id", "branchingConfigured"]);

      //Since omit does not support deep remove, we have to delete the nextQueston key from the options because nextQueston is used for branching
      _.map(questionObj.options, function(option) {
        delete option.nextQuestion;
      });

      //If the question type is "IMAGE" then we need to use languageImageOptions
      if (questionObj.type && questionObj.type.toLowerCase() === "image" && questionObj.languageImageOptions) {
        //Since English languague will alwats be at 0 index that's why
        _.map(questionObj.languageImageOptions[0].options, function(option) {
          delete option.nextQuestion;
        });
      }

      //Create our duplicate question object.
      const duplicateQuestion = Object.assign({}, questionSample, questionObj);
      //Add a new key to this duplicate object which will let backend know that its a duplicate question
      duplicateQuestion.isDuplicate = true;

      duplicateQuestion.sequence = questionObj.sequence + 1;
      duplicateQuestion.stepSequence = questionObj.stepSequence + 1;

      if (isBranchingConfigured) {
        duplicateQuestion.branchingConfigured = false;
        if (duplicateQuestion.nextQuestionId) {
          duplicateQuestion.nextQuestionId = "";
        }
        if (duplicateQuestion.recursiveLoopEndQuestionId) {
          duplicateQuestion.recursiveLoopEndQuestionId = null;
        }
        if (duplicateQuestion.branchingOptions) {
          duplicateQuestion.branchingOptions = [];
        }
        if (duplicateQuestion.type.toLowerCase() !== "image") {
          for (let i = 0; i < duplicateQuestion.options.length; i++) {
            if (duplicateQuestion.options[i].nextQuestion) {
              duplicateQuestion.options[i].nextQuestion = "";
            }

            if (duplicateQuestion.options[i].nextQuestionIdList) {
              duplicateQuestion.options[i].nextQuestionIdList = [];
            }
          }
        } else {
          for (let i = 0; i < duplicateQuestion.languageImageOptions[0].options.length; i++) {
            duplicateQuestion.languageImageOptions[0].options[i].nextQuestion = "";
          }
        }
      }

      /** Map Data Duplicate Logic START */
      if (duplicateQuestion.hasOwnProperty("isDataMapped") && duplicateQuestion.isDataMapped) {
        duplicateQuestion.isDataMapped = false;
        duplicateQuestion.mapLabel = "";
      }
      /** Map Data Duplicate Logic END */
      //Finally save the nw duplicated question.
      //this.$store.dispatch("addActivityQuestionAction", duplicateQuestion);
      duplicateQuestion.branchingConfigured = this.toggleBranchingConfiguration(duplicateQuestion);
      this.$api.addActivityQuestionFact(this.activityId, duplicateQuestion).then(response => {
        const newQuestion = response.data.result;
        this.activityData.questions.splice(newQuestion.stepSequence, 0, newQuestion);
        newQuestion["columns"] = [];
        newQuestion["columnCount"] = 0;
        this.activityRows.splice(newQuestion.stepSequence, 0, newQuestion);

        this.reOrderSteps();
      });
    },
    toggleBranchingConfiguration(quesObj) {
      if (quesObj.type !== "Section") {
        return activityService.checkIfQuestionHasBranchingConfiguration(quesObj);
      } else {
        return false;
      }
    },
    reorderQuestion(question, parent) {
      let deleteButtonFlag = this.showDeleteButton;
      deleteButtonFlag = false;
      this.$emit("update-delete-flag", deleteButtonFlag);
      this.reorderError = true;
      this.reorderQuestionColumn = question;
      this.reorderQuestionRow = parent;
      this.reorderQuestionIndex = parent == null ? this.activityRows[question].stepSequence : this.activityRows[parent]["columns"][question].stepSequence;

      this.$refs.reorderingModal.show();
    },
    setFocusOnReorderQuestionTo(event) {
      event.vueTarget.$refs.body.childNodes[1].childNodes[1].focus();
      this.$refs.reorderQuestionTo.focus();
    },
    async reOrderCheckBranching() {
      let branchingQuestions = activityService.isBranchingConfigured(this.activityRows);
      //let theSelectedQuestion = (this.reorderQuestionRow !== null) ? this.activityRows[this.reorderQuestionRow].columns[this.reorderQuestionColumn] : this.activityRows[this.reorderQuestionColumn];
      if (branchingQuestions.length > 0) {
        swal({
          title: "Please be advised that that this activity has branching logic setup. We suggest you review and revise it as needed. Would you like to continue?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#b8c7ce",
          cancelButtonColor: "#34537d",
          confirmButtonText: "Cancel",
          cancelButtonText: "Yes"
        }).then(({ dismiss }) => {
          if (dismiss === "cancel") {
            const reorderResponse = activityService.reorderActivityQuestionColumn(this.activityRows, this.reorderQuestionTo, this.reorderQuestionColumn, this.reorderQuestionRow);
            if (reorderResponse.error === null) {
              this.activityRows = reorderResponse.rows;
            } else {
              toastr.error(reorderResponse.error);
            }

            this.reOrderSteps();
            this.$refs.reorderingModal.hide();
          } else {
            this.$refs.reorderingModal.hide();
          }
        });
      } else {
        const reorderResponse = activityService.reorderActivityQuestionColumn(this.activityRows, this.reorderQuestionTo, this.reorderQuestionColumn, this.reorderQuestionRow);
        if (reorderResponse.error === null) {
          this.activityRows = reorderResponse.rows;
        } else {
          toastr.error(reorderResponse.error);
        }

        this.reOrderSteps();
        this.$refs.reorderingModal.hide();
      }
    },
    checkDuplicate(questionObj) {
      const branchingQuestions = activityService.isBranchingConfigured(this.activityRows);
      if (branchingQuestions.length > 0) {
        swal({
          title: "Please be advised that that this activity has branching logic setup. We suggest you review and revise it as needed. Would you like to continue?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#b8c7ce",
          cancelButtonColor: "#34537d",
          confirmButtonText: "Cancel",
          cancelButtonText: "Yes"
        }).then(({ dismiss }) => {
          if (dismiss === "cancel") {
            this.duplicateQuestion(questionObj);
          }
        });
      } else {
        this.duplicateQuestion(questionObj);
      }
    },
    reOrderQuestionPosition() {
      const questionToMove = _.cloneDeep(this.activityRows[this.reorderQuestionIndex - 1]);

      this.activityRows.slice(parseInt(this.reorderQuestionTo) - 1, 0, questionToMove);
      this.reOrderSteps();
    },
    resetReorderObj() {
      this.reorderQuestionIndex = null;
      this.reorderQuestionTo = null;
    },
    updateQuestionsSequence(seqUpdatedQuesObj) {
      this.$api.updateActivityQuestionOrderFact(this.activityId, seqUpdatedQuesObj).then(
        response => {
          const questionAnswers = response.body.result.questions;
          this.$store.dispatch("activityQuestionsAction", questionAnswers);
          // when we swap scale questions its design is distorted so
          // refreshing the scale to redesign
          this.$nextTick(() => {
            if (this.$refs.slider) {
              this.$refs.slider.forEach((slide, i) => {
                this.$refs.slider[i].refresh();
              });
            }
          });
          toastr.success("Your steps order has been successfully updated");
        },
        error => {
          this.activityQuestions = this.questions;
          for (let i = 0, seq = 1; i < this.activityQuestions.length; i++) {
            if (this.activityQuestions[i].type && this.activityQuestions[i].type != "Section") {
              this.activityQuestions[i].stepSequence = seq++;
            }
          }
          this.errorMsg = error.body ? error.body.message : "Error while changing order";
        }
      );
    },
    closeReorderModal() {
      this.$refs.reorderingModal.hide();
    },
    // polyfilled smooth scrolling for IE, Edge & Safari
    smoothScrollTo(to, duration) {
      const element = document.scrollingElement || document.documentElement;

      const start = element.scrollTop;

      const change = to - start;

      const startDate = +new Date();

      // t = current time
      // b = start value
      // c = change in value
      // d = duration
      const easeInOutQuad = (tOld, b, c, d) => {
        let t = tOld;
        t /= d / 2;
        if (t < 1) {
          const tMulti = (c / 2) * t * t;
          return tMulti + b;
        }
        t--;
        const tVal = t * (t - 2);
        const tVal1 = tVal - 1;
        const tVal2 = (-c / 2) * tVal1;
        return tVal2 + b;
      };

      const animateScroll = () => {
        const currentDate = +new Date();
        const currentTime = currentDate - startDate;
        element.scrollTop = parseInt(easeInOutQuad(currentTime, start, change, duration));
        if (currentTime < duration) {
          requestAnimationFrame(animateScroll);
        } else {
          element.scrollTop = to;
        }
      };
      animateScroll();
    },

    // GROUP SCORING

    isNewGroup(question) {
      if (question && question.type === "Section") {
        return false;
      }
      return true;
    },

    doesQuestionHasSectionAboveIt(question, index) {
      if (question.type === "Section") {
        return false;
      }
      if (index === 0) {
        return false;
      }
      const aboveQuestion = this.activityRows[index - 1];
      if (aboveQuestion) {
        if (aboveQuestion.type === "Section") {
          return true;
        }
        return false;
      }
      return false;
    },

    addNewGroup(question, index) {
      const sectionJson = _.cloneDeep(sectionJSON);
      const activeEditGroup = {};
      this.sectionModificationMode = "ADD";
      const prevSectionsArray = this.activityRows.filter(o => o.type == "Section" && o.sequence < index);
      Object.keys(sectionJson).forEach(key => {
        activeEditGroup[key] = sectionJson[key];
      });
      activeEditGroup.nextQuestionId = question.id;
      activeEditGroup.sequence = prevSectionsArray.length > 0 ? prevSectionsArray[prevSectionsArray.length - 1].sequence + 1 : 1;
      activeEditGroup.title += " " + activeEditGroup.sequence;
      this.selectedActivityQuestion = activeEditGroup;
      this.$emit("onSectionAddEdit", activeEditGroup);
    },

    editSection(question) {
      this.sectionModificationMode = "EDIT";
      const sectionToEdit = _.cloneDeep(question);
      this.selectedActivityQuestion = sectionToEdit;
      this.$emit("onSectionAddEdit", sectionToEdit);
    },

    // This method is called when new section is added for the POST call
    saveNewGroupInformation(question, index) {
      const section = _.cloneDeep(this.activeEditGroup[question.id]);
      this.editQuestion(section, index);
    },

    saveExistingGroupInformation(questionId) {
      // call this below function after success of API call
      this.$delete(this.activeEditGroup, questionId);
    },

    onSectionUpdated() {
      this.$emit("update:activeEditGroup", null);
    },
    getDefaultPositionValueForCustomScale(question) {
      const defaultPointerPosition = question.defaultPointerPosition;
      if (defaultPointerPosition == "none" || defaultPointerPosition == "left") {
        return question.formattedLabels[0];
      } else if (defaultPointerPosition == "right") {
        return question.formattedLabels[question.formattedLabels.length - 1];
      } else if (defaultPointerPosition == "middle") {
        const l = question.formattedLabels.length;
        if (l % 2 == 0) {
          const halfLength = l / 2;
          return question.formattedLabels[halfLength - 1];
        } else {
          return question.formattedLabels[(l - 1) / 2];
        }
      } else {
        return question.formattedLabels[0];
      }
    },
    showPointerInfo() {
      this.pointerInfoDiv = true;
      this.$el.focus();
    },

    hidePointerInfo() {
      this.pointerInfoDiv = false;
      this.$el.blur();
    },
    togglePointerInfo() {
      if (this.pointerInfoDiv) {
        this.hidePointerInfo();
      } else {
        this.showPointerInfo();
      }
    },
    addToBatchDelete(question, $event) {
      if (!$event) {
        if (this.batchDeleteQuestions.some(selectedQuestion => selectedQuestion.id == question.id)) {
          this.batchDeleteQuestions.splice(
            this.batchDeleteQuestions.findIndex(que => que.id === question.id),
            1
          );
        }
      } else if ($event) {
        this.batchDeleteQuestions.push(question);
      }
    }
  }
};
</script>

<style scoped lang="scss">
li.dropdown-submenu:hover ul li[disabled="disabled"] {
  color: #afafaf;
}

.activity-questions {
  margin: 0 -15px;
}

.draggable-row {
  display: flex;

  .col-md-4 {
    display: inline-block;
  }

  .col-md-6 {
    display: inline-block;
  }

  .draggable-placeholder {
    border: 3px dashed #d3dee3;
    height: 90%;
    border-radius: 5px;
  }

  .draggable-placeholder:-moz-drag-over {
    display: none;
  }
}

#notificationModal .close-dialog-icon {
  position: absolute;
  right: 10px;
  top: 5px;
  cursor: pointer;
}

h1,
h2,
h3 {
  font-weight: 200;
}

.wid300 {
  max-width: 300px !important;
}

.img-style {
  padding-top: 20px;
  height: 300px;
  width: 500px;
  padding-bottom: 20px;
}

.question_body {
  word-break: break-all;
  color: #959fa4;
}

.read_only_question {
  border-left: 1px solid #d3dfe4 !important;
  background-color: #f5f8fa;
}

.icon-style {
  color: #57dd7a;
  font-size: 25px;
  padding-top: 20px;
  background-color: #d6f0de;
  padding: 7px;
  padding-bottom: 3px;
  border-radius: 25px;
}

.font-style {
  color: #57dd7a;
  font-size: 16px;
  padding-top: 10px;
  padding-bottom: 30px;
}

// Style for quick fixes bootstrap after migration (before redesign should be removed)

.option-section {
  &:after {
    content: "";
    clear: both;
    display: block;
  }

  .col-sm-3 {
    float: left;
  }
}

// END of style for quick fixes bootstrap after migration (before redesign should be removed)

h1,
h2,
h3 {
  font-weight: 200;
}

.img-style {
  padding-top: 20px;
  height: 300px;
  width: 500px;
  padding-bottom: 20px;
}

.question_body {
  word-break: break-all;
  color: #959fa4;
}

.read_only_question {
  border-left: 1px solid #d3dfe4 !important;
  background-color: #f5f8fa;
}

.icon-style {
  color: #57dd7a;
  font-size: 25px;
  padding-top: 20px;
  background-color: #d6f0de;
  padding: 7px;
  padding-bottom: 3px;
  border-radius: 25px;
}

.font-style {
  color: #57dd7a;
  font-size: 16px;
  padding-top: 10px;
  padding-bottom: 30px;
}

.text-style {
  color: #969090;
  text-align: right;
}

.btn-style {
  margin-top: 10px;
  width: 80px;
  height: 29px;
  margin-bottom: 50px;
}

.custom-btn {
  background: #00baf9;
  color: #fff;
  width: 220px;
}

.pad-top50 {
  padding-top: 50px;
}

.form-control {
  border-radius: 2px;
}

.custom-para {
  padding-bottom: 20px;
  font-size: 20px;
}

.mar-bot20 {
  margin-bottom: 20px;
}

.error-style {
  font-size: 12px;
  color: #ff4848;
  padding-bottom: 5px;
}

.readonly {
  background: #f7f7f7;
}

.btn-disabled {
  color: white;
  background-color: #c6c2c2;
  border: #c6c2c2;
}

.text-color {
  color: #888;
}

.survey-name {
  color: #00baf9;
  font-size: 20px;
}

.pad-left50 {
  padding-left: 50px;
}

.branching_section {
  // background-color: #f5f8fa;
  // border: solid 1px #d3dfe4;
  padding: 5px 0px;

  .branching_image {
    max-width: 120px;
    max-height: 120px;
    width: 100%;
    border: 1px solid #ccc;
  }
}

.custom-btn-bg {
  background: linear-gradient(to left, #4b6fe6, #00baf9);
  color: #fff;
}

.mar-bot20 {
  margin-bottom: 20px;
}

.pad-left100 {
  padding-left: 100px;
}

.mar-bot0 {
  margin-bottom: 0px !important;
}

.card {
  border: 1px solid rgba(0, 0, 0, 0.125);
  padding: 15px;
  margin-bottom: 16px;
}

.question_color,
input {
  color: #666769;
  font-size: 14px;
}

.radio-option {
  margin: 0px;

  label {
    padding-left: 5px;
  }
}

.input-text {
  width: 100%;
  border-radius: 2px;
  outline: none;
  border: 1px solid #ccc;
  height: 35px;
  text-indent: 10px;
}

.small-input {
  padding: 0;
  height: 25px;
  text-indent: 5px;
  background: #fff;
  width: 100px;
}

.date-input {
  border-radius: 20px;
  outline: none;
  border: 1px solid #ccc;
  height: 35px;
  text-indent: 10px;
}

.pad-top20 {
  padding-top: 20px;
}

.vertical-vue-slider {
  height: 300px !important;
  width: 4px;
  padding: 11px;
  margin-left: 30px;
}

.vertical-vue-slider-vas {
  width: 4px;
  padding: 11px;
  margin-left: 30px;
}

.horizontal-vue-slider {
  height: 8px;
  width: 100%;
}

.img-size {
  width: 100%;
  height: auto;
  float: none;
  max-width: 120px;
  max-height: 120px;
  padding-left: 5px;
}

label {
  font-weight: normal !important;
  word-break: break-all;
  color: #959fa4;
}

.modal-dialog {
  width: 500px !important;
}

.instruction_title {
  word-break: break-all;
  font-size: 18px;
  font-weight: bold;
}

.instruction_info {
  word-break: break-all;
}

.edit_button {
  background-color: #ffffff;
  border: 1px solid #d3dfe4;
  font-size: 12px;
}

.drag_img {
  position: relative;
  bottom: 1px;
  margin-right: 6px;
}

.scaleLabels {
  font-size: 12px;
  color: #666669;
}

.scaleLabels-vas {
  font-size: 12px;
  color: #666669;
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.display-inline {
  display: inline-block;
  padding-left: 5px;
}

/deep/ .vue-slider-component .vue-slider-tooltip {
  display: none;
}

input[type="radio"] {
  vertical-align: middle;
}

#reorderingModal {
  .move-btn {
    background-color: #4c8ce4;
    border-color: #4c8ce4;
    border-radius: 20px;
    padding: 5px 30px;
  }

  button.close {
    margin-top: -2px;
  }

  .modal-title {
    font-size: 15px;
    font-weight: bold;
  }

  .invalid-feedback {
    display: block;
    font-size: 13px;
    max-width: 165px;
  }
}

.lang-img-options .col-auto {
  margin-right: 126px !important;
}

.lang-img-options .col-auto:last-of-type {
  margin-right: 0 !important;
}

.language-name {
  color: #959fa4;
}

.group-scoring {
  &__container {
    border-radius: 3px;

    &-filled,
    &-edit {
      border: solid 1px #b0bac9;
      background-color: #b0bac9;
      height: 40px;
      padding: 10px 13px;
    }

    &-only-display {
      height: 30px;
    }
  }

  &__name-input {
    flex-basis: 75%;
  }
}

.section_weight {
  background-color: #eee;
  border-radius: 3px;
  color: #000;
  line-height: 26px;
  padding: 0 10px;
  text-align: right;
}

.branching-border {
  border-top: 1px solid #d3dfe4;
  // border-bottom: 1px solid #d3dfe4;
}

.clearbranchimage {
  vertical-align: middle;
  padding: 3px;
  border: 1px solid #d3dfe4;
  background: #d3dfe4;
  opacity: 0.6;
  border-radius: 3px;
}

.branchingsavebtn {
  width: 88px;
  border-radius: 4px;
  background-color: #4c8ce4;
  border-radius: 2px solid #4c8ce4;
  display: flex;
  justify-content: center;
  padding: 6px;
  cursor: pointer;
}

.branchingbtntext {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #ffffff;
}

.cancelbranchingbtn {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #666669;
  margin: 14px;
  cursor: pointer;
}

.branchingsteptitalname {
  font-size: 18px;
  line-height: 1.33;
  letter-spacing: normal;
  color: #000000;
}

.branchingstep {
  padding: 20px 5px 5px 20px;
}

.branchingstepcount {
  font-size: 14px;
  color: #000000;
  font-weight: bold;
}

.beanchinglogictext {
  font-size: 14px;
  color: #000000;
}

.Add_another_branch {
  font-size: 12px;
  font-weight: bold;
  color: #4c8ce4;
  cursor: pointer;
}

.branchingsteptitalname p {
  margin-bottom: 0;
}

.branching-select-option {
  width: 50px;
  height: 23px;
  border-radius: 3px;
  font-size: 12px;
  border: solid 1px #d3dfe4;
  padding-top: 1px;
}

.priority-no {
  position: relative;
  top: 13px;
  font-size: 14px;
  font-weight: bold;
  color: #000000;
}

.priority-img {
  opacity: 0.6;
}

.rotate-180deg {
  transform: rotate(180deg);
}

.fa-info-circle {
  color: #959fa4;
  margin-left: -13px;
}

.group-scoring__container-empty {
  background-color: #ffffff;
  height: 30px;
  padding: 5px 13px;
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23B0BAC9FF' stroke-width='2' stroke-dasharray='6%2c 14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
}

.ql-editor.p-0 {
  overflow-y: unset;
}

.action-dropdown-menu {
  line-height: 27px;
  font-size: 12px;
  padding: 0.125rem 0.75rem;
  box-shadow: rgba(0, 0, 0, 0.1) 1px 1px 1px 1px;
  min-width: 7rem;
}

.settings-dropdown-item {
  line-height: 27px;
  padding: 0.125rem 0.75rem;
  cursor: pointer;
  border-bottom: 1px solid #dee2e6;
}

li.settings-dropdown-item:last-child {
  border-bottom: none;
}

.settings-action-icon {
  cursor: pointer;
  /* height: 25px; */
  /* margin-right: -6px; */
  height: 20px;
}

.draggable-2 {
  background-repeat: no-repeat;
  background-image: url(/static/img/draggable-2.jpg);
  background-size: 100% 95%;
  background-position: top;
  padding: 0px 0px 8px 0px;
}

.draggable-3 {
  background-repeat: no-repeat;
  background-image: url(/static/img/draggable-3.jpg);
  background-size: 100% 93%;
  background-position: top;
  padding-bottom: 15px;
}

.draggable-row.draggable-2 .col-md-6 {
  background-repeat: no-repeat;
  background-image: url(/static/img/draggable-2-after.jpg);
  background-size: 100% 100%;
  background-position: center;
  padding: 0px 15px 5px 15px;
}

.draggable-row.draggable-3 .col-md-4 {
  background-repeat: no-repeat;
  background-image: url(/static/img/draggable-3-after.jpg);
  background-size: 100% 100%;
  background-position: center;
  padding: 0px 15px 1px 15px;
}

.dropdown-submenu {
  position: relative;
}

.dropdown-submenu > .dropdown-menu {
  top: 0;
  left: -102%;
  margin-top: 0px;
  margin-left: 0px;
  -webkit-border-radius: 2px 0 2px 2px;
  -moz-border-radius: 2px 0 2px 2px;
  border-radius: 2px 0 2px 2px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.25);
}

.dropdown-submenu .file {
  left: -91% !important;
}

.dropdown-submenu:hover > .dropdown-menu {
  display: block;
  min-width: 7rem;
}

.dropdown-submenu:hover > a:after {
  border-left-color: #fff;
}

.dropdown-submenu.pull-left {
  float: none;
}

.dropdown-submenu.pull-left > .dropdown-menu {
  left: -100%;
  margin-left: 10px;
  -webkit-border-radius: 6px 0 6px 6px;
  -moz-border-radius: 6px 0 6px 6px;
  border-radius: 6px 0 6px 6px;
}

.dropleft .dropdown-toggle::before {
  border-right: 0 !important;
  transform: rotate(45deg);
  background-color: #4c8ce4;
}

.export_img {
  margin-left: -10px;
  height: 13px;
}

.draggable-3 .card,
.draggable-2 .card {
  height: 100%;
}

.activity-step-checkbox {
  float: left;
  padding-left: 0px;
  margin-left: 5px;
  margin-right: 5px;
}
.section-title {
  font-size: 18px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  text-align: left;
  color: #666669;
}
</style>
